var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#334C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M504.084 319.427C493.709 359.851 473.627 397.132 445.581 428.037C417.535 458.942 382.371 482.537 343.141 496.775L230.4 384L245.524 321.112L197.827 273.415C238.282 196.682 319.461 134.737 319.461 134.737L504.084 319.427Z",
    fill: "url(#paint0_linear_6_96)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320.876 231.781L316.632 267.419C316.448 269.074 315.659 270.603 314.414 271.71C313.17 272.818 311.56 273.425 309.895 273.415H272.842V379.183C272.851 380.446 272.36 381.661 271.477 382.563C270.594 383.466 269.389 383.982 268.126 384H230.366C229.738 383.991 229.118 383.859 228.541 383.61C227.964 383.362 227.442 383.002 227.004 382.552C226.566 382.101 226.221 381.569 225.989 380.985C225.757 380.401 225.642 379.778 225.651 379.149L225.853 273.415H197.794C196.007 273.415 194.293 272.705 193.03 271.442C191.767 270.178 191.057 268.465 191.057 266.678V231.04C191.057 229.253 191.767 227.54 193.03 226.276C194.293 225.013 196.007 224.303 197.794 224.303H225.684V189.743C225.684 149.76 249.465 128 284.295 128H312.825C314.612 128 316.326 128.71 317.589 129.973C318.852 131.237 319.562 132.95 319.562 134.737V164.749C319.562 166.536 318.852 168.25 317.589 169.513C316.326 170.777 314.612 171.486 312.825 171.486H295.343C276.413 171.789 272.842 180.851 272.842 194.392V224.202H314.307C315.253 224.218 316.185 224.434 317.043 224.834C317.9 225.234 318.663 225.811 319.283 226.526C319.903 227.241 320.365 228.078 320.639 228.984C320.914 229.889 320.994 230.842 320.876 231.781Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_96",
    x1: 237.676,
    y1: 222.147,
    x2: 437.726,
    y2: 422.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2D52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1E2C52",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.f1b01329e2aa1cdd2c3d093e7c4dfbae.svg";
export { ForwardRef as ReactComponent };